// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2Usw_","wrapper-nopadding":"wrapper-nopadding__3ZoAX","loading":"loading__1MrGh","error":"error__3sRFt","table-loading":"table-loading__vtKfR","empty-val":"empty-val__1ON4l","panelheader-tools":"panelheader-tools__2XBOE","propsPanels":"propsPanels__aawGm","new":"new__3u_uZ","marginLm":"marginLm__vQE6p","marginRm":"marginRm__1mOQn","fullWidth":"fullWidth__s0asg","fullHeight":"fullHeight__2xO7g","noData":"noData__11X0X","spectrum":"spectrum__3Fcgr","freq":"freq__3OhZd","tooltip":"tooltip__l--MN","label":"label__wMGFx"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Network/coms/ChannelView/coms/FreqSpectrum/styles.scss
// module id = 2293
// module chunks = 1